// import { useParams, useNavigate } from "react-router-dom";
// import { useState } from "react";

// const API_HOST =
//   process.env.REACT_APP_API ||
//   process.env.REACT_APP_API_BASE_URL ||
//   "http://localhost:5000";                 // em produção fica REACT_APP_API=https://api.lucianacosta.cv
// const API = `${API_HOST}/api`;

// export default function ResetPassword() {
//   const { token } = useParams();
//   const nav = useNavigate();
//   const [pwd, setPwd] = useState("");
//   const [pwd2, setPwd2] = useState("");
//   const [sub, setSub] = useState(false);
//   const [err, setErr] = useState("");
//   const [ok, setOk] = useState("");

//   async function onSubmit(e) {
//     e.preventDefault();
//     if (sub) return;
//     setErr(""); setOk("");

//     if (pwd.length < 8) { setErr("A password deve ter pelo menos 8 caracteres."); return; }
//     if (pwd !== pwd2)   { setErr("As passwords não coincidem."); return; }

//     setSub(true);
//     try {
//       const r = await fetch(`${API}/auth/reset`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         // Em DEV, se te causar CORS, comenta a linha abaixo ou autoriza localhost:3000 no backend
//         credentials: "include",
//         body: JSON.stringify({ token, password: pwd }),
//       });
//       const j = await r.json().catch(() => ({}));
//       if (!r.ok) throw new Error(j.error || "Não foi possível redefinir a password.");
//       setOk("Password atualizada. Já podes iniciar sessão.");
//       setTimeout(() => nav("/login", { replace: true }), 800);
//     } catch (e) {
//       setErr(
//         /Failed to fetch/i.test(String(e?.message))
//           ? "Falha de ligação à API (CORS/ligação)."
//           : e.message
//       );
//     } finally {
//       setSub(false);
//     }
//   }

//   return (
//     <main className="container py-4">
//       <h1>Definir nova password</h1>

//       {err && <div className="alert alert-danger">{err}</div>}
//       {ok  && <div className="alert alert-success">{ok}</div>}

//       <form onSubmit={onSubmit} className="login-form auth-card p-4">
//         <div className="form-row mb-3">
//           <label className="form-label">Nova password</label>
//           <input
//             className="form-control"
//             type="password"
//             value={pwd}
//             onChange={e => setPwd(e.target.value)}
//             required minLength={6}
//             autoComplete="new-password"
//           />
//         </div>
//         <div className="form-row mb-4">
//           <label className="form-label">Confirmar password</label>
//           <input
//             className="form-control"
//             type="password"
//             value={pwd2}
//             onChange={e => setPwd2(e.target.value)}
//             required minLength={6}
//             autoComplete="new-password"
//           />
//         </div>

//         <button className="button button-primary w-100" disabled={sub}>
//           {sub ? "A guardar…" : "Guardar e entrar"}
//         </button>
//       </form>
//     </main>
//   );
// }
import { useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";

const API_HOST = process.env.REACT_APP_API || "https://api.lucianacosta.cv";
const API = `${API_HOST}/api`;

export default function ResetPassword() {
  const { token } = useParams();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [sub, setSub] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const navigate = useNavigate();

  const validToken = useMemo(() => !!token && token.length > 10, [token]);

  async function onSubmit(e) {
    e.preventDefault();
    if (sub) return;
    setMsg(""); setErr("");

    if (!validToken) { setErr("Link inválido."); return; }
    if (pw.length < 8) { setErr("A password deve ter pelo menos 8 caracteres."); return; }
    if (pw !== pw2) { setErr("As passwords não coincidem."); return; }

    setSub(true);
    try {
      const r = await fetch(`${API}/auth/reset`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ token, password: pw }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || "Não foi possível redefinir a password.");
      setMsg("Password redefinida com sucesso. Já podes iniciar sessão.");
      setTimeout(() => navigate("/login"), 1500);
    } catch (e) {
      setErr(/Failed to fetch/i.test(String(e?.message))
        ? "Falha de ligação à API."
        : e.message);
    } finally {
      setSub(false);
    }
  }

  return (
    <div className="auth-page py-4">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-7 col-xl-5">
            <h1 className="auth-title h2 mb-3">Definir nova password</h1>

            {msg && <div className="alert alert-success">{msg}</div>}
            {err && <div className="alert alert-danger">{err}</div>}

            <div className="auth-card p-4 p-md-4">
              {!validToken ? (
                <p>Link inválido ou em falta.</p>
              ) : (
                <form onSubmit={onSubmit} noValidate>
                  <div className="mb-3">
                    <label className="form-label">Nova password</label>
                    <input
                      className="form-control"
                      type="password"
                      value={pw}
                      onChange={e => setPw(e.target.value)}
                      minLength={8}
                      required
                    />
                  </div>
                  <div className="mb-4">
                    <label className="form-label">Confirmar password</label>
                    <input
                      className="form-control"
                      type="password"
                      value={pw2}
                      onChange={e => setPw2(e.target.value)}
                      minLength={8}
                      required
                    />
                  </div>
                  <button className="btn btn-primary w-100" disabled={sub}>
                    {sub ? "A guardar…" : "Guardar nova password"}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
